<template>
    <div class="login-page" ref="login">
        <van-row v-if="success==false">
            <van-col span="20" offset="2">
                <div class="vant-main">
                    <van-cell-group class="van-hairline--bottom">
                        <van-field
                                v-model="loginForm.username"
                                left-icon="contact"
                                placeholder="请输入登录账号"
                                autocompleted="false"
                        />
                    </van-cell-group>
                    <van-cell-group>
                        <van-field
                                v-model="loginForm.password"
                                type="password"
                                left-icon="bag-o"
                                placeholder="请输入登录密码"
                                autocompleted="false"
                        />
                    </van-cell-group>
                    <van-cell-group :style="{marginTop:'.5rem'}">
                        <van-button type="info" class="login-btn" @click="handleSubmit" :loading="loading" loading-text="绑定中..." size="small" block>立即绑定</van-button>
                    </van-cell-group>
                </div>
            </van-col>
        </van-row>
        <van-row v-else  class="vant-main">
            <van-icon name="success" color="#5daf34"/>
            <p>恭喜您已成功绑定微信，此微信将作为您账号佣金提现的唯一微信，若要更换微信，请在PC后台解绑后，重新进行微信绑定</p>
        </van-row>
    </div>
</template>

<script>
    export default {
        name: "wxbind",
        data() {
            return {
                loading:false,
                openid:'',
                loginForm:{
                    username:'',
                    password:''
                },
                success:false
            };
        },
        methods: {
            handleSubmit(){
                if(!this.loginForm.username){
                    this.$toast.fail('请输入账号');
                    return false;
                }
                if(!this.loginForm.password){
                    this.$toast.fail('请输入密码');
                    return false;
                }
                this.loginForm.openid = this.openid
                this.loading = true
                this.fetchDataPost('/user/bind',this.loginForm,(res)=>{
                    this.loading = false;
                    if(res.code){
                        this.success = true;
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            }
        },
        created() {
            let href = location.href;
            if (href.includes("//wxbind")) {
                let url = href.substring(0, href.indexOf('#'));
                let jingPosit = url.indexOf("//wxbind"); //获取域名结束的位置
                let urlLeft = url.substring(0, jingPosit);//url左侧部分
                let urlRight = url.substring(jingPosit+1, url.length); //url右侧部分
                let redirect = urlLeft+"/#" + urlRight;
                alert(redirect)
               location.href = redirect//拼接跳转
            }
            if(this.$route.query.appid){
                sessionStorage.setItem('appid',this.$route.query.appid)
            }
            if(!this.openid){
                let code = this.$route.query.code;
                let url = encodeURIComponent(location.href.replace("#",''));
                if (!code) {
                    this.$toast.loading('登录..')
                    this.fetchData('/wechat/authUrl', {url: url,needInfo:1}, (res) => {
                        this.$toast.clear();
                        if (res.code) {
                            location.href = res.url;
                        } else {
                            this.$toast.fail(res.msg)
                        }
                    })
                }
                if (code) {
                    this.$toast.loading('登录..')
                    this.fetchData('/wechat/getopenidForce', {code: code}, (res) => {
                        this.$toast.clear();
                        if (res.code) {
                           this.openid = res.data;
                           sessionStorage.setItem('token',res.data)
                        } else {
                            this.$toast.fail(res.msg)
                        }
                    })
                }
            }
        },
    };
</script>
<style>
    .vant-main{
        margin-top: 4rem;
        padding: .4rem .2rem;
        border-radius: .1rem;
        opacity: .9;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }
    .vant-main p{
        font-size: .26rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/wxbind.vue